module.exports = __webpack_public_path__ + "media/images/lb/406-a5135b4c2ad197d79795c66cfe3aba9c.svg";